import { ChevronRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";

/**
 * Path Indicator
 *
 * Shows CSR their current path through the branching questions.
 * Helps them understand:
 * - Which answers they've selected so far
 * - Where they are in the conversation
 *
 * Example: "Issue: Billing > Type: Payment Issue"
 */

export interface PathStep {
  question: string;
  answer: string;
}

export interface PathIndicatorProps {
  steps: PathStep[];
  currentQuestionIndex?: number;
}

export function PathIndicator({ steps }: PathIndicatorProps) {
  if (steps.length === 0) {
    return null;
  }

  return (
    <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
      <div className="text-xs font-semibold uppercase tracking-wide text-blue-700 mb-2">
        📍 Your Path
      </div>

      <div className="flex flex-wrap items-center gap-2">
        {steps.map((step, idx) => (
          <div key={idx} className="flex items-center gap-2">
            <div className="flex flex-col gap-1">
              <div className="text-xs text-blue-600 font-semibold">
                {step.question}
              </div>
              <Badge className="text-xs">
                {step.answer}
              </Badge>
            </div>
            {idx < steps.length - 1 && (
              <ChevronRight className="h-4 w-4 text-blue-400 mx-1" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
